const Item = <template>{{yield @item}}</template>;

export default Item;
